export enum ESensorLinkedRelayMode {
  NO_RELAY,
  RELAY_AUTO_ON,
  RELAY_OFF_BY_ADMIN,
  RELAY_ON_OFF_BY_ADMIN
}
